var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#f0f0f0"}},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('the-snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }